import React from 'react'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Box from '@mui/material/Box'
import { withTranslation } from 'react-i18next'
import DeleteDialog from '../../DeleteDialog'
import 'react-block-ui/style.css'
import { authContext } from '../../../contexts/AuthContext'
import { Link } from 'react-router-dom'
import CPDeleteIconButton from '../../Utils/CPDeleteIconButton'
import CPSettingsIconButton from '../../Utils/CPSettingsIconButton'
import { apiUrl } from '../../../config/api'

class ClientListItem extends React.Component {
  // Fila de lista para cada cliente en Clientes.js
  constructor() {
    super()

    this.state = {
      deleteClient: {}
    }
  }

  static contextType = authContext

  handleDeleteClientOpen = (client) => {
    this.setState({
      deleteClient: client
    })
  }

  handleDialogClose = () => {
    this.setState({
      deleteClient: {}
    })
  }

  deleteClient = (client) => {
    client.loggedUserId = this.context.auth.user.id
    client.brandLabel = window.$brand
    client.workspaceId = this.props.workspaceId

    let url = apiUrl('DeleteClient')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(client)
    })
      .then((res) => console.log(res))
      .then((success) => {
        console.log('Delete successful')
      })
      .catch((error) => console.log(error))

    this.props.cardDeleteHandler(client)
  }

  render() {
    const { t, client } = this.props
    const isAdmin =
      this.context.auth.user.userType === 'blp_admin' ||
      this.context.auth.user.userType === 'blp_user' ||
      this.context.auth.user.userType === 'external_admin'

    return (
      <ListItem
        divider
        disablePadding
        secondaryAction={
          isAdmin && (
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Link
                to={{
                  pathname: '/Administracion',
                  state: { client }
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <CPSettingsIconButton />
              </Link>
              <CPDeleteIconButton
                onClick={(e) => {
                  e.stopPropagation()
                  this.handleDeleteClientOpen(client)
                }}
              />
            </Box>
          )
        }
      >
        <ListItemButton
          component={Link}
          to={{
            pathname: `/client/${client.id}`,
            state: { client }
          }}
        >
          <ListItemText
            primary={client.name}
            secondary={client.license || null}
          />
        </ListItemButton>

        <DeleteDialog
          item={this.state.deleteClient}
          title={
            window.$brand === 'ZAP' ? t('delete_condo') : t('delete_client')
          }
          caption={
            window.$brand === 'ZAP'
              ? t('delete_condo_full_caption')
              : t('delete_client_full_caption')
          }
          targetFunc={this.deleteClient}
          handleDialogClose={this.handleDialogClose}
        />
      </ListItem>
    )
  }
}

export default withTranslation()(ClientListItem)
